import React from "react";
import {useCollapse} from "react-collapsed";
import { ChevronUp, ChevronDown } from "lucide-react";
import { ICON_SIZE } from "components/common/constants";

const CollapsableSettingsCard = ({title, subtitle, content}: {
    title: string;
    subtitle: string;
    content: React.ReactNode
}): React.ReactElement => {

    const {getCollapseProps, getToggleProps, isExpanded} = useCollapse();

    return (
        <div className={"setting_collapsable-main bg-white radius-4"}>
            <div {...getToggleProps()} className="p-16 ast_collapseble">
                {isExpanded?
                    <ChevronUp className="float-right" size={ICON_SIZE.MEDIUM}/>:
                    <ChevronDown className="float-right" size={ICON_SIZE.MEDIUM}/>
                }
                <h3><strong>{title}</strong></h3>
                <div>{subtitle}</div>
            </div>
            <section {...getCollapseProps()} className="pb-4 ast_collapseble-section">
                {content}
            </section>
        </div>
    );
};

export default CollapsableSettingsCard;